var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersatileletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24.5C48 11.5213 37.4787 1 24.5 1C11.5213 1 1 11.5213 1 24.5C1 37.4787 11.5213 48 24.5 48C37.4787 48 48 37.4787 48 24.5Z",
    fill: "#FEFAF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24.5C48 11.5213 37.4787 1 24.5 1C11.5213 1 1 11.5213 1 24.5C1 37.4787 11.5213 48 24.5 48C37.4787 48 48 37.4787 48 24.5Z",
    stroke: "#F7B27A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16L27.0056 36H20.9944L14 16H19.1124L24 31.0997L28.9157 16H34Z",
    fill: "#EF6820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersatileletter);
export default __webpack_public_path__ + "static/media/versatileletter.04b05004822cfe652dfe9c6932c8e010.svg";
export { ForwardRef as ReactComponent };